export default __webpack_public_path__ + "static/media/pdc_mobility_step2.9c32feb3.svg";